@if (updateReady) {
  <div id="update-ready" (click)="updateReady = false" [@updateVisibilityAnimation]>
    CurbNTurf has been updated please refresh
    <span> X </span>
  </div>
}
